import {ABILITY_SPARKLES} from '../../configs/abilitySparkleAnimation';

/**
 * Состояние искр способности над отрядом в момент timeMs (см.
 * configs/abilitySparkleAnimation): каждая искра плавно разгорается и
 * притухает по синусоиде, соседние — со сдвигом на долю круга, по порядку.
 * @param {number} timeMs — общее время сцены (scene.time.now)
 * @param {number} count — сколько искр
 * @returns {{alpha: number, scale: number}[]} по искре; scale — множитель к ее
 *   размеру
 */
export const getAbilitySparkleStates = (timeMs, count) => {
  const {cycleMs, minAlpha, minScale, maxScale} = ABILITY_SPARKLES;
  const time = Number.isFinite(timeMs) ? timeMs : 0;
  const cyclePhase = (((time % cycleMs) + cycleMs) % cycleMs) / cycleMs;

  return Array.from({length: count}, (item, index) => {
    const brightness = 0.5 - 0.5 * Math.cos(2 * Math.PI * (cyclePhase - index / count));
    return {
      alpha: minAlpha + (1 - minAlpha) * brightness,
      scale: minScale + (maxScale - minScale) * brightness,
    };
  });
};
